module.exports = __webpack_public_path__ + "static/5-a705702413932ebd9e6eddad1ed0e8a1.png";